import React from "react";
import ReactDOM from "react-dom";
import "./tailwind.css";
import "antd/dist/antd.css";
import "./css/main.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import jwt_decode from "jwt-decode";

// const checkIfTokenExpires = () => {
//   const token: string = localStorage.getItem("authToken") ?? "";
//   const decoded: any = jwt_decode(token);
//   const exp = decoded.exp;
//   const expirationTime = exp * 1000 - 60000;
//   if (Date.now() >= expirationTime) {
//     localStorage.clear();
//   }
// };

// checkIfTokenExpires();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root") as HTMLElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
